import React, { useCallback, useState } from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Download, Loader2 } from "lucide-react";
import { useBluelagoon } from "@bluelagoon";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

const triggerDownload = (payload, chatId) => {
    const blob = new Blob([JSON.stringify(payload, null, 2)], {
        type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const stamp = new Date().toISOString().replace(/[:.]/g, "-");
    a.href = url;
    a.download = `chat-${chatId}-${stamp}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

export default function ExportChatButton({ chatId }) {
    const { t } = useTranslation();
    const { call: exportStepChat } = useBluelagoon({ method: "exportStepChat" });
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = useCallback(async () => {
        if (!chatId || isExporting) return;
        setIsExporting(true);
        try {
            const res = await exportStepChat({ stepChatId: chatId });
            const payload = res?.data?.data ?? res?.data;
            if (!payload || payload.version !== 1) {
                toast.error(t("adminChats.export.failed"));
                return;
            }
            triggerDownload(payload, chatId);
            toast.success(t("adminChats.export.success"));
        } catch (e) {
            toast.error(t("adminChats.export.failed"));
        } finally {
            setIsExporting(false);
        }
    }, [chatId, exportStepChat, isExporting, t]);

    return (
        <Button
            variant="outline"
            size="sm"
            onClick={handleExport}
            disabled={!chatId || isExporting}
        >
            {isExporting ? (
                <Loader2 className="w-4 h-4 mr-1 animate-spin" />
            ) : (
                <Download className="w-4 h-4 mr-1" />
            )}
            {t("adminChats.export.button")}
        </Button>
    );
}
